module.exports = __webpack_public_path__ + "img/img22.ace8d5f0.png";